import React, { Component } from 'react';
import axios from "axios";
import {appConfig} from "./../tools/AppConfig";

import Waiting from './../modules/waiting';
import Message from './errors/message';
import SimpleHeader from './../modules/simpleHeader_new';
import Lucky from './../modules/iframes/paymentMethods/lucky/lucky';
import Easypaisa from './../modules/iframes/paymentMethods/Easypaisa/Easypaisa';
import JazzCash from './../modules/iframes/paymentMethods/JazzCash/JazzCash';
import Tabby from './../modules/iframes/paymentMethods/Tabby/Tabby';
import TabbyPos from './../modules/iframes/paymentMethods/TabbyPos/TabbyPos';
import Spotii from '../modules/iframes/paymentMethods/Spotii/Spotii';
import Nift from './../modules/iframes/paymentMethods/Nift/Nift';
import OnlineCard from './../modules/iframes/paymentMethods/OnlineCard/OnlineCard';
import ConsumerDiscounts from '../modules/iframes/paymentMethods/consumerDiscounts/ConsumerDiscounts';
import Souhoola from '../modules/iframes/paymentMethods/Souhoola/Souhoola';
import Blnk from "../modules/iframes/paymentMethods/Blnk/Blnk";
import Contact from '../modules/iframes/paymentMethods/Contact/Contact';
import Sympl from '../modules/iframes/paymentMethods/Sympl/Sympl';
import SouhoolaV3 from '../modules/iframes/paymentMethods/SouhoolaV3/SouhoolaV3';
import './iframes.css';
import AmanV3 from '../modules/iframes/paymentMethods/AmanV3/AmanV3';
import Instapay from '../modules/iframes/paymentMethods/Instapay/Instapay';
import Halan from '../modules/iframes/paymentMethods/Halan/Halan';

class iframes extends Component {
  constructor(props){
    super(props);
    this.state = {
      current_method_data: {},
      waiting: true,
      invaild_link: false,
      invaild_link_message: "",
      initialPaymentData: null
    };
  }
  componentDidMount(){
    var url_string = window.location.href;
    var url = new URL(url_string);
    if(url.searchParams.get("3ds")){
        localStorage.popup_3d_secure = true;
    }else if(url.searchParams.get("payment_token")){
      this.load_current_method(url.searchParams.get("payment_token"));
    }else{
      if(this.props.match.params.payment_token){
        this.load_current_method(this.props.match.params.payment_token);
      }else{
        this.setState({waiting: false, invaild_link: true, invaild_link_message: "invaild url, missing payment_token."})
      }
    }
  }
  load_current_method = (payment_token) => {
    let url = appConfig.getServerUrl() + '/api/acceptance/standalone?payment_token=' + payment_token;
    let config = {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          // "Cache-Control": "no-cache"
        }
    };
    axios.get(
        url,
        config
    )
    .then((resp)=>{
      this.setState({
        waiting: false,
        current_method_data: resp.data,
        initialPaymentData: resp.data
      })
    })
    .catch((err)=>{
      this.setState({
        waiting: false, 
        invaild_link: true,
        invaild_link_message: "invaild payment_token."
      })
    });
  }
  render_complate_page = (head, body) => {
    let domain = window.location.hostname;
    let lang = localStorage.lang !== undefined ? localStorage.lang : "en";
    if(domain === "localhost"){
        domain = "acceptstagingtest.paymobsolutions.com"
    } else {
        domain = "accept.paymob.com"
    }
    let regURL = "https://" + domain + "/portal2/"+ lang +"/register";
    return(
      <div className="newStandalone complate_message_div">
        <div className="invoice">
          <div className="standaloneBody">
            <SimpleHeader acq_partner={this.state.acq_partner} acq_partner_data={this.state.styleData}/>
            <Message head={head} body={body} />
            <div className="startSell">
                <p>Start selling your products</p>
                <a href={regURL} target="_blank">Get Started<i className="fa fa-arrow-right"></i></a>
            </div>
          </div>
        </div>
      </div>
    )
  }
  render_invalid_link = () => {
    return this.render_complate_page("error", this.state.invaild_link_message)
  }
  render_main_body = () => {
    let final_payment_token;
    var url_string = window.location.href;
    var url = new URL(url_string);
    if(this.props.match.params.payment_token){
      final_payment_token = this.props.match.params.payment_token;
    }else{
      final_payment_token = url.searchParams.get("payment_token");
    }
    return(
      <div>
        {this.state.current_method_data.gateway == "LUCKY_INSTALLMENT" ? 
          <Lucky 
            payment_token={final_payment_token}
          /> 
        // :
        // this.state.current_method_data.gateway == "MIGS" ? 
        //   <OnlineCard 
        //     payment_token={final_payment_token}
        //   /> 
        // :
        :
        this.state.current_method_data.gateway == "MIGS" || this.state.current_method_data.gateway == "VPC" ? 
          this.state.current_method_data.has_discount ?
            <ConsumerDiscounts 
              platform="iframe"
              payment_token={final_payment_token}
            />
          :
            <OnlineCard 
              payment_token={final_payment_token}
              is_installment={this.state.current_method_data.bank_installments}
            />
        :
        this.state.current_method_data.gateway == "EASYPAISA" ?
          <Easypaisa
            payment_token={final_payment_token}
          /> 
        :
        this.state.current_method_data.gateway == "NIFT" ?
          <Nift
            payment_token={final_payment_token}
          /> 
        :
        this.state.current_method_data.gateway == "JAZZCASH" ?
          <JazzCash
            payment_token={final_payment_token}
          /> 
        :
        this.state.current_method_data.gateway == "TABBY" && this.state.current_method_data.type == "online" ?
          <Tabby
            payment_token={final_payment_token}
          />
        :
        this.state.current_method_data.gateway == "TABBY" && this.state.current_method_data.type == "in_store" ?
          <TabbyPos
            payment_token={final_payment_token}
          />
        :
        this.state.current_method_data.gateway == "SPOTII" ?
          <Spotii
            payment_token={final_payment_token}
          /> 
        :
        this.state.current_method_data.gateway === "SOUHOOLAV2" ?
          <Souhoola
            payment_token={final_payment_token}
          /> 
          :
          this.state.current_method_data.gateway === "BLNK" ?
          <Blnk
            payment_token={final_payment_token}/>
            :
        this.state.current_method_data.gateway === "SOUHOOLAV3" ?
          <SouhoolaV3
              payment_token={final_payment_token}
          /> 
        :
        this.state.current_method_data.gateway === "SYMPL_V2" ?
          <Sympl
            payment_token={final_payment_token}
          /> 
        :
        this.state.current_method_data.gateway === "CONTACT" ?
        <Contact
          payment_token={final_payment_token}
        /> 
        :
        this.state.current_method_data.gateway === "AMANV3" ?
          <AmanV3
            payment_token={final_payment_token}
          />
        :
        this.state.current_method_data.gateway === "INSTAPAY" ?
        <Instapay
          payment_token={final_payment_token}
          initialPaymentData={this.state.initialPaymentData}
        />
        :
        this.state.current_method_data.gateway === "HALAN" ?
        <Halan
          payment_token={final_payment_token}
        />
        :
          this.render_complate_page("error", "invalid payment method.")
        }
      </div>
    )
  }
  render() {
    return(
      <div className="iframes_main">
        {this.state.waiting ?
          <Waiting height='100vh' />
        :
          <div>
            {this.state.invaild_link ?
              this.render_invalid_link()
            :
              this.render_main_body()
            }
          </div>
        }
      </div>
    )
  }
}

export default iframes;
